import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import AccountInfo from "./Components/AccountInfo";
import Missions from "./Components/Missions";
import Custom from "../../Components/Buttons/Custom";
import MainStats from "./Components/MainStats";
import Clock from "./Components/Clock";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../config/api";
export default function Overview() {
  const navigate = useNavigate();
  const { accountId } = useParams();
  const [rulesData, setRulesData] = useState(null);
  const [accLoading, setAccLoading] = useState(true);
  const [ruleLoading, setRuleLoading] = useState(true);
  const fetchRulesData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}challenges/trader/accounts/${accountId}/rules/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}challenges/trader/accounts/${accountId}/rules/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setRulesData(data);
      setRuleLoading(false);
    } catch (error) {
      setRuleLoading(false);
      console.error("Error fetching account data:", error);
    }
  };
  const [accountData, setAccountData] = useState(null);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}challenges/trader/accounts/${accountId}/data/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try to refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → log out and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return; // ⬅️ IMPORTANT: stop here
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new access token
          response = await fetch(
            `${API_BASE_URL}challenges/trader/accounts/${accountId}/data/`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            },
          );
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // handle final response (original or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
      setAccLoading(false);
    } catch (error) {
      console.error("Error fetching account data:", error);
      setAccLoading(false);
    }
  };
  useEffect(() => {
    fetchRulesData();
    fetchAccountData();
  }, []);
  return (
    <LayoutPage
      activeIndex={3}
      navItems={["حساب‌ها و چالش‌ها", `حساب ${accountData?.account?.code}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["حساب در یک نگاه", "جزئیات معاملات"]}
        hrefs={[
          `/challenge/account/${accountId}/overview`,
          `/challenge/account/${accountId}/trade-detail`,
        ]}
        activeIndex={0}
      />
      <div className="w-full h-fit flex flex-col sm:flex-row gap-5 min-h-0 overflow-y-auto">
        <div className="flex-1 min-w-0 h-fit flex flex-col gap-5">
          <AccountInfo accountData={accountData} accLoading={accLoading} />
          <Missions
            rulesData={rulesData}
            accountData={accountData}
            ruleLoading={ruleLoading}
          />
        </div>

        <div className="w-full sm:size-fit flex flex-col gap-5">
          {accountData && accountData?.account.status === "live" && (
            <Custom
              text="معامله در این حساب"
              svg_name="trade"
              svgClassName="stroke-white"
              href={`/trade/${accountId}/trade`}
              className="bg-zi-gradient-button-blue text-zi-text-dark w-full px-3.5 hocus:ring-inset hocus:ring-1 hocus:ring-offset-1 hocus:ring-offset-zi-border-dark hocus:ring-zi-border-light"
              textShadow={true}
              svgShadow={true}
            />
          )}
          <MainStats accountData={rulesData} accLoading={accLoading} />
          {accountData && accountData?.account.status === "live" && <Clock />}
        </div>
      </div>
    </LayoutPage>
  );
}
